<td>
  <b>{{ field.displayName }}</b>
</td>
@if (field.fieldType == ProfileFieldType.Address) {
  <td>
    @if (hasAddress) {
      <span [innerHTML]="profile | portalAddressFormat | async"></span>
      @if (
        profile.validationStatus &&
        isPortalValidateAddress &&
        profile.validationMessage
      ) {
        <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
          @if (profile.validationStatus === 'Success') {
            <mat-icon class="success">check_circle</mat-icon>
          }
          @if (profile.validationStatus === 'Warning') {
            <mat-icon color="accent">warning</mat-icon>
          }
          @if (profile.validationStatus === 'Error') {
            <mat-icon color="warn">warning</mat-icon>
          }
          <span>{{ profile.validationMessage }}</span>
        </span>
      }
    } @else {
      <span class="empty-value">Empty</span>
    }
  </td>
  <td class="action-cell">
    <button
      mat-icon-button
      class="outlined-button"
      [attr.aria-label]="
        field.readOnly
          ? 'Address is read only'
          : hasAddress
            ? 'Edit address'
            : 'Add address'
      "
      [disabled]="field.readOnly"
      (click)="dialog.editAddress()"
    >
      <mat-icon>{{
        field.readOnly ? 'lock' : hasAddress ? 'edit' : 'add'
      }}</mat-icon>
    </button>
  </td>
}
@if (field.fieldType != ProfileFieldType.Address) {
  @if (field.fieldType == ProfileFieldType.FullName) {
    <td>{{ profile | portalProfileName }}</td>
    <td class="action-cell">
      <button
        mat-icon-button
        class="outlined-button"
        [attr.aria-label]="field.readOnly ? 'Name is read only' : 'Edit name'"
        [disabled]="field.readOnly"
        (click)="dialog.editName()"
      >
        <mat-icon>{{ field.readOnly ? 'lock' : 'edit' }}</mat-icon>
      </button>
    </td>
  }
  @if (field.fieldType == ProfileFieldType.Email) {
    <td style="padding-right: 0">
      <app-email-editor
        [primaryEmail]="profile.email"
        [secondaryEmails]="profile.secondaryEmails"
        [addFn]="addEmailFn"
        [deleteFn]="deleteEmailFn"
        [makePrimaryFn]="makePrimaryEmailFn"
        (verify)="verifyEmail.emit($event)"
      ></app-email-editor>
    </td>
  }
  @if (field.fieldType == ProfileFieldType.Phone) {
    <td>
      @if (profile.phoneNumber) {
        <div fxLayout="row">
          <span>{{ profile.phoneNumber | phoneNumberDisplay }}</span>
          @if (profile.extension) {
            <span>, Ext {{ profile.extension }}</span>
          }
        </div>
      } @else {
        <span class="empty-value">Empty</span>
      }
    </td>
    <td class="action-cell">
      <button
        mat-icon-button
        class="outlined-button"
        [attr.aria-label]="
          field.readOnly
            ? 'Phone number is read only'
            : profile.phoneNumber
              ? 'Edit phone number'
              : 'Add phone number'
        "
        [disabled]="field.readOnly"
        (click)="dialog.editPhoneNumber()"
      >
        <mat-icon>{{
          field.readOnly ? 'lock' : profile.phoneNumber ? 'edit' : 'add'
        }}</mat-icon>
      </button>
    </td>
  }
  @if (field.fieldType == ProfileFieldType.JobTitle) {
    <td>
      @if (profile.jobTitle) {
        {{ profile.jobTitle }}
      } @else {
        <span class="empty-value">Empty</span>
      }
    </td>
    <td class="action-cell">
      <button
        mat-icon-button
        class="outlined-button"
        [attr.aria-label]="
          field.readOnly
            ? 'Job title is read only'
            : profile.jobTitle
              ? 'Edit job title'
              : 'Add job title'
        "
        [disabled]="field.readOnly"
        (click)="dialog.editJobTitle()"
      >
        <mat-icon>{{
          field.readOnly ? 'lock' : profile.jobTitle ? 'edit' : 'add'
        }}</mat-icon>
      </button>
    </td>
  }
  @if (field.fieldType == ProfileFieldType.Company) {
    <td>
      @if (profile.company) {
        {{ profile.company }}
      } @else {
        <span class="empty-value">Empty</span>
      }
    </td>
    <td class="action-cell">
      <button
        mat-icon-button
        class="outlined-button"
        [attr.aria-label]="
          field.readOnly
            ? 'Company information is read only'
            : profile.company
              ? 'Edit company information'
              : 'Add company information'
        "
        [disabled]="field.readOnly"
        (click)="dialog.editCompany()"
      >
        <mat-icon>{{
          field.readOnly ? 'lock' : profile.company ? 'edit' : 'add'
        }}</mat-icon>
      </button>
    </td>
  }
  @if (field.fieldType == ProfileFieldType.LinkedInProfile) {
    <td>
      @if (profile.linkedInProfile) {
        {{ profile.linkedInProfile }}
      } @else {
        <span class="empty-value">Empty</span>
      }
    </td>
    <td class="action-cell">
      <button
        mat-icon-button
        class="outlined-button"
        [attr.aria-label]="
          field.readOnly
            ? 'LinkedIn profile is read only'
            : profile.linkedInProfile
              ? 'Edit LinkedIn profile'
              : 'Add LinkedIn profile'
        "
        [disabled]="field.readOnly"
        (click)="dialog.editLinkedInProfile()"
      >
        <mat-icon>{{
          field.readOnly ? 'lock' : profile.linkedInProfile ? 'edit' : 'add'
        }}</mat-icon>
      </button>
    </td>
  }
}

<update-portal-profile-dialog
  #dialog
  [profile]="profile"
  (profileUpdated)="profile = $event"
></update-portal-profile-dialog>
